import useFetch from "../../hooks/useFetch";
import UserService from "../UserService";
import { IUserData, UserRegistrationRequest } from "../../types/services-types/user-types";
import { setAuth } from "../../store/reducers/user-reducer";
import { useAppDispatch } from "../../store";

export default function useRegistration(payload: UserRegistrationRequest) {
    const dispatch = useAppDispatch()
    const [registration, isLoading, error, errors] = useFetch(async () => {
        const data = await UserService.Registration(payload)
        localStorage.setItem('accessToken', data.tokens.access_token)
        dispatch(setAuth(data.user))
        return data
})

return {registration, isLoading, error, errors}
}